import React from 'react';
import { CreateJobOpeningContainer } from './containers/CreateJobOpeningContainer';

export const JobOpeningsCreate = () => {
  return <CreateJobOpeningContainer />;
};
